import { HttpClient, HttpContext, HttpContextToken } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: "root",
})
export class ClientIpService {
  constructor(private readonly httpClient: HttpClient) {}

  getClientIp(): Promise<string> {
    return firstValueFrom(
      this.httpClient.get<{ ip: string }>("https://api.ipify.org?format=json", {
        context: new HttpContext().set(SKIP_AUTH, true),
      })
    )
      .then((res) => res.ip ?? "")
      .catch(() => "");
  }
}
